import { Component, Vue, Inject } from "vue-property-decorator";
import DZModelAbout from "@/views/网站信息/DZModelAbout";
import UIEditor from "@/components/ui-editor/UIEditor.vue"
import nyNetwork from "@/api/nyBaseNetwork";
@Component({
    components: {UIEditor}
})
export default class Index extends Vue {

    created() {
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    $refs: any;

    table_height = 0;

    is_dialog_show = false

    m_about = new DZModelAbout();

    list_about : Array<DZModelAbout> = []

    action_editor_change(text){
        this.m_about.content = text
    }

    dialog_close(){
        this.m_about = new DZModelAbout();
        this.is_dialog_show = false
    }

    handle_add(){
        this.m_about = new DZModelAbout();
        this.is_dialog_show = true
    }

    handle_edit(row){
        this.m_about = JSON.parse(JSON.stringify(row))
        this.is_dialog_show = true
    }

    handle_delete(row){
        nyNetwork.net("关于我们删除",row, res => {
            this.action_list_data()
        })
    }

    action_list_data(){
        nyNetwork.net("关于我们列表",{}, res => {
            if(res){
                this.list_about = res
                this.list_about.forEach(o =>{
                    o.status = parseInt(o.status) === 1
                })
            }
        })
    }

    handle_submit(){
        if(!this.m_about.title || !this.m_about.content){
            this.$message.error("输入不能为空")
            return
        }
        nyNetwork.net("关于我们编辑",this.m_about, res => {
            this.m_about = new DZModelAbout();
            this.is_dialog_show = false
            this.action_list_data()
        })
    }

    changeStatus(id){
        nyNetwork.get("关于我们状态",{"id":id}, res => {
            this.action_list_data()
        })
    }
}
